export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-page-pdf-e700be222345f5c8104433619769be34.svg";